/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./appearance-skin-dialog.vue?vue&type=template&id=5a4bccb9&"
import script from "./appearance-skin-dialog.vue?vue&type=script&lang=ts&"
export * from "./appearance-skin-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports